import React from 'react';
import { DashboardMetricTone, DashboardSystemMetric } from '../../types/dashboard';

interface SystemHealthSectionProps {
  metrics: DashboardSystemMetric[];
}

const toneTextClassMap: Record<DashboardMetricTone, string> = {
  positive: 'text-emerald-400',
  primary: 'text-green-300',
  warning: 'text-amber-300',
  critical: 'text-rose-400',
};

export const SystemHealthSection: React.FC<SystemHealthSectionProps> = ({ metrics }) => {
  return (
    <section className="relative isolate mt-12 overflow-hidden rounded-card bg-c-1f1f1f px-5 py-8 text-white shadow-[0_20px_60px_rgb(var(--c-080a14,8_10_20)/0.35)] sm:mt-14 sm:px-8 sm:py-12 md:mt-16">
      <div aria-hidden className="pointer-events-none absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgb(var(--c-1f1f1f,31_31_31)/1)_0%,rgb(var(--c-1f1f1f,31_31_31)/1)_56%,rgb(var(--c-171e2c,23_30_44)/0.96)_74%,rgb(var(--c-0c3549,12_53_73)/0.9)_100%)]" />
        <div className="absolute -right-[38%] top-[27%] h-[1585px] w-[1585px] -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(17,172,182,0.34)_0%,rgba(17,172,182,0)_66%)]" />
      </div>

      <div className="relative z-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-6">
        <div className="min-w-0 lg:col-span-4">
          <h3 className="text-[2rem] font-medium leading-[1.08] sm:text-[2.4rem] lg:text-[3rem]">Business Snapshot</h3>
          <p className="mt-3 text-sm text-white/75">
            <span className="mr-2 inline-block h-2.5 w-2.5 rounded-full bg-emerald-400" />
            Real numbers from your workspace
          </p>
        </div>

        <div className="grid grid-cols-2 gap-6 lg:col-span-8 lg:grid-cols-4">
          {metrics.map((metric) => (
            <div key={metric.id} className="min-w-0">
              <p className={`text-4xl font-semibold tracking-tight sm:text-5xl lg:text-7xl ${toneTextClassMap[metric.tone]}`}>{metric.value}</p>
              <p className="mt-2 text-base text-white/90 sm:text-xl lg:text-2xl">{metric.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
